export const normalizeStyles = (rawStyles: string | null | undefined) => {
  if (rawStyles) return rawStyles.trimEnd();
  return "";
};

export const getBackgroundImageURL = (
  backgroundImage: string | null | undefined,
  isPageEditing: boolean,
) => {
  if (backgroundImage) {
    const mediaUrlPattern = /mediaurl="([^"]*)"/i;
    if (mediaUrlPattern.exec(backgroundImage ?? "")) {
      const mediaUrl = mediaUrlPattern.exec(backgroundImage)?.[1] || "";
      return isPageEditing ? toRelativePathUrl(mediaUrl) : mediaUrl;
    }
  }
  return null;
};

export const getBackgroundImageStyle = (
  backgroundImage: string | null | undefined,
) => {
  if (backgroundImage) {
    return {
      backgroundImage: `url('${backgroundImage}')`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      backgroundColor: "transparent",
    };
  } else {
    return {};
  }
};

export function toRelativePathUrl(url: string) {
  try {
    if (url.includes("ecolab.com")) {
      const u = new URL(url);
      return u.pathname + u.search;
    }
    return url;
  } catch {
    return url;
  }
}

export function detectPositionClass(classString: string): string {
  const positions = ["position-center", "position-left", "position-right"];
  const tokens = new Set(classString.trim().split(/\s+/));

  for (const pos of positions) {
    if (tokens.has(pos)) {
      return pos;
    }
  }

  return "";
}

export const getConfiguredHeadingStyles = (tag: string) => {
  switch (tag.toLowerCase()) {
    case "h1":
      return "text-[34px] [&_*]:text-[34px] leading-[52px] [&_*]:leading-[52px] lg:text-[42px] lg:[&_*]:text-[42px]";
    case "h2":
      return "text-[28px] [&_*]:text-[28px] leading-[35px] [&_*]:leading-[35px] lg:text-[32px] lg:[&_*]:text-[32px] lg:leading-[52px] lg:[&_*]:leading-[52px]";
    case "h3":
      return "text-[20px] [&_*]:text-[20px] leading-[28px] [&_*]:leading-[28px] lg:text-[24px] lg:[&_*]:text-[24px] lg:leading-[30px] lg:[&_*]:leading-[30px]";
    case "h4":
      return "text-[16px] [&_*]:text-[16px] leading-[22px] [&_*]:leading-[22px] lg:text-[20px] lg:[&_*]:text-[20px] lg:leading-[28px] lg:[&_*]:leading-[28px]";
    default:
      return "text-base";
  }
};

export const extractHiddenBlock = (gridClass: string | null | undefined) => {
  if (!gridClass) {
    return "";
  }
  return gridClass
    .split(" ")
    .filter((cls) => {
      const base = cls.split(":").pop();
      return base === "hidden" || base === "block";
    })
    .join(" ");
};
